export const getContent = (array: string[] = [], numberOfItems = 3) => {
  const firstItems = array.slice(0, numberOfItems).join(', ')
  const remainingCount = Math.max(array.length - numberOfItems, 0)

  return remainingCount > 0 ? `${firstItems}, +${remainingCount} more` : firstItems
}
